// Builds a CSS `url('...')` value from an image address. Characters that break
// a CSS url (quotes, brackets, backslash, whitespace, control chars) make the
// browser drop the whole declaration, so they are percent-encoded. Everything
// else (including existing `%XX` sequences) is left alone to avoid double encoding.
export default function cssUrl(address) {
  if (typeof address !== 'string' || !address) {
    return 'none'
  }

  // eslint-disable-next-line no-control-regex
  const escaped = address.replace(/['"()\\ \u0000-\u001f\u007f]/g, char => {
    return '%' + char.charCodeAt(0).toString(16).toUpperCase().padStart(2, '0')
  })

  return `url('${escaped}')`
}

export { cssUrl }
